"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

var _react = _interopRequireDefault(require("react"));

var _react2 = require("@chakra-ui/react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Index = _ref => {
  var {
    trigger,
    handleAlert,
    title,
    description
  } = _ref;

  var [isOpen, setIsOpen] = _react.default.useState(false);

  var onClose = () => {
    setIsOpen(false);
    handleAlert(false);
  };

  var handleConfirm = () => {
    setIsOpen(false);
    handleAlert(true);
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    onClick: () => setIsOpen(true)
  }, " ", trigger(), " "), /*#__PURE__*/_react.default.createElement(_react2.AlertDialog, {
    isOpen: isOpen,
    onClose: onClose,
    isCentered: true
  }, /*#__PURE__*/_react.default.createElement(_react2.AlertDialogOverlay, null, /*#__PURE__*/_react.default.createElement(_react2.AlertDialogContent, null, /*#__PURE__*/_react.default.createElement(_react2.AlertDialogHeader, {
    fontSize: "lg",
    fontWeight: "bold"
  }, title), /*#__PURE__*/_react.default.createElement(_react2.AlertDialogBody, null, description), /*#__PURE__*/_react.default.createElement(_react2.AlertDialogFooter, null, /*#__PURE__*/_react.default.createElement(_react2.Button, {
    onClick: onClose
  }, "Cancelar"), /*#__PURE__*/_react.default.createElement(_react2.Button, {
    colorScheme: "red",
    onClick: handleConfirm,
    ml: 3
  }, "Confirmar"))))));
};

var _default = Index;
exports.default = _default;